import { Box, Divider, Group, Stack, Title } from '@mantine/core';
import CreateNoteButton from '@/features/note/components/CreateNoteButton';
import { Todo } from '@/common/types/databaseTypes';
import { useNotesByTodoId } from '@/features/note/services/useNoteQueries';
import { useEffect, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { ko } from 'date-fns/locale';
import ActivityItem, {
    Activity,
} from '@/features/goal/components/activity/ActivityItem';
import { useTranslation } from 'react-i18next';

interface Props {
    todo: Todo;
    activities?: Activity[];
}

export default function TodoActivityFeed({ todo, activities = [] }: Props) {
    const { t } = useTranslation('todo');
    const { data: todoNotes } = useNotesByTodoId(todo.id);
    const [noteActivities, setNoteActivities] = useState<Activity[]>([]);

    useEffect(() => {
        if (todoNotes) {
            const noteActivityDatas: Activity[] = todoNotes.map(note => {
                return {
                    user: note.register,
                    time: formatDistanceToNow(new Date(note.register_date), {
                        addSuffix: true,
                        locale: ko,
                    }),
                    note: note,
                };
            });
            setNoteActivities(noteActivityDatas);
        }
    }, [todoNotes]);

    // 모든 활동 항목을 합치고 시간순으로 정렬
    const allActivities = [...activities, ...noteActivities];

    return (
        <Stack gap={0}>
            <Divider />
            <Group justify="space-between" gap="md" mt="md">
                <Title order={6} size="xl" fw={600}>
                    {t('component.activity')}
                </Title>
                <CreateNoteButton todoId={todo.id} />
            </Group>
            <Box pt="xs">
                {allActivities.map((activity, index) => (
                    <ActivityItem key={index} {...activity} />
                ))}
            </Box>
        </Stack>
    );
}
